export default "__VITE_ASSET__AKytkyNS__"